import * as React from 'react';
import { IndexRedirect, Route } from 'react-router';

import Container from 'bundles/authoring-ai-tools/AuthoringAIContainer';
import { ROUTES } from 'bundles/authoring-ai-tools/lib/constants';
import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';

const Home = loadOnRoute(() => import('bundles/authoring-ai-tools/pages/Home'));
const Tool = loadOnRoute(() => import('bundles/authoring-ai-tools/pages/Tool'));
const Atlas = loadOnRoute(() => import('bundles/authoring-ai-tools/components/Atlas/Atlas'));

export default (
  <Route name="authoring-ai-tools" path="authoring-ai-tools" component={Container}>
    <IndexRedirect to={ROUTES.HOME} />
    <Route path={ROUTES.HOME} getComponent={Home} />
    <Route path={`${ROUTES.TOOL}/atlas`} getComponent={Atlas} />
    <Route path={`${ROUTES.TOOL}/:toolId`} getComponent={Tool} />
    {/* Catch-all 404 route */}
    <Route path="*" component={NotFound} />
  </Route>
);
